module.exports = __webpack_public_path__ + "assets/img/5dfdfd40ad410da3879ee7db7a4c0b19.png";